import type { RootState } from "@src/store/rootState";
import { selectedExperience } from "@src/store/slices/experiences";
import {
  getProductPickerData,
  getProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";

export const isValidProductPickerSelection = (state: RootState) => {
  const data = getProductPickerData(state);
  const experience = selectedExperience(state);
  const selectedProducts = getProductPickerSelectedProducts(state);
  if (
    data?.type === "analytics" ||
    data?.type === "selectedAnalyticsProducts" ||
    data?.type === "gwp" ||
    data?.type === "onsiteUpsellAction" ||
    data?.type === "onsiteUpsellCartVariants" ||
    data?.type === "onsiteUpsellPdpProducts"
  ) {
    return selectedProducts.length > 0;
  }
  if (experience.testTypes.hasTestCampaign) {
    return true;
  } else {
    return selectedProducts.length > 0;
  }
};
